import { toTypedSchema } from '@vee-validate/zod'
import * as z from 'zod'

/**
 * Login form validation schema
 */
export const loginSchema = toTypedSchema(
  z.object({
    email: z.string().min(1, 'Email is required').email('Please enter a valid email address'),
    password: z
      .string()
      .min(1, 'Password is required')
      .min(6, 'Password must be at least 6 characters')
  })
)

/**
 * Forgot password form validation schema
 */
export const forgotPasswordSchema = toTypedSchema(
  z.object({
    email: z.string().min(1, 'Email is required').email('Please enter a valid email address')
  })
)

/**
 * Reset password form validation schema
 */
export const resetPasswordSchema = toTypedSchema(
  z
    .object({
      token: z.string().min(1, 'Token is required'),
      email: z.string().min(1, 'Email is required').email('Please enter a valid email address'),
      password: z
        .string()
        .min(1, 'Password is required')
        .min(8, 'Password must be at least 8 characters'),
      password_confirmation: z.string().min(1, 'Please confirm your password')
    })
    .refine((data) => data.password === data.password_confirmation, {
      message: "Passwords don't match",
      path: ['password_confirmation']
    })
)
